import React, {useState} from 'react';

interface IUser {
  id: number | undefined | null,
  login: string | undefined | null,
  authorized: boolean | undefined,
  role_id: number | undefined,
  is_special: boolean | undefined,
  is_access_by_district: boolean | null | undefined,
  district_id: number | null | undefined,
}

interface IUserContext {
  currentUser: IUser,
  setCurrentUser: any
}

export const undefinedUser: IUser = {
  id: undefined,
  login: undefined,
  authorized: undefined,
  role_id: undefined,
  is_special: undefined,
  is_access_by_district: undefined,
  district_id: undefined,
};

export const unauthorizedUser: IUser = {
  id: undefined,
  login: undefined,
  authorized: false,
  role_id: undefined,
  is_special: undefined,
  is_access_by_district: undefined,
  district_id: undefined,
};

const defaultUserContext = {
  currentUser: undefinedUser,
  setCurrentUser: undefined,
};

export const UserContext = React.createContext<IUserContext>(
  defaultUserContext);

export const useUserState = (): IUserContext => {
  const [currentUser, setCurrentUser] = useState<IUser>(undefinedUser);
  return {
    currentUser: currentUser,
    setCurrentUser: setCurrentUser,
  };
};
